export const messages = {
  en: {
    parkingAreaManage: {
      queryTitle: 'Query Conditions',
      parkingInfo: 'Parking Area Information',
      parkingId: 'Parking ID',
      parkingNum: 'Parking Number',
      parkingType: 'Parking Type',
      inputParkingNum: 'Please enter parking number',
      selectParkingType: 'Please select parking type',
      aboveGround: 'Above Ground Parking',
      underground: 'Underground Parking',
      remark: 'Remark',
      createTime: 'Create Time',
      operation: 'Operation',
      controlPanel: 'Control Panel',
      addTitle: 'Add Parking Area',
      editTitle: 'Edit Parking Area',
      deleteTitle: 'Confirm Operation',
      deleteConfirm: 'Are you sure to delete this parking area?',
      numRequired: 'Parking number is required',
      typeRequired: 'Parking type is required',
      remarkPlaceholder: 'Optional, please enter remark',
      attr1: 'Area Size',
      attr1Placeholder: 'Please enter area size',
      attr2: 'Parking Type',
      selectAttr2: 'Please select parking type',
      option1: 'Standard',
      option2: 'VIP',
      column1: 'Capacity',
      column2: 'Available',
      addSuccess: 'Parking area added successfully',
      addFailed: 'Failed to add parking area',
      editSuccess: 'Parking area updated successfully',
      editFailed: 'Failed to update parking area',
      deleteSuccess: 'Parking area deleted successfully',
      deleteFailed: 'Failed to delete parking area',
      fetchError: 'Failed to fetch parking area data'
    }
  },
  zh: {
    parkingAreaManage: {
      queryTitle: '查询条件',
      parkingInfo: '停车场信息',
      parkingId: '停车场ID',
      parkingNum: '停车场编号',
      parkingType: '停车场类型',
      inputParkingNum: '请输入停车场编号',
      selectParkingType: '请选择停车场类型',
      aboveGround: '地上停车场',
      underground: '地下停车场',
      remark: '备注',
      createTime: '创建时间',
      operation: '操作',
      controlPanel: '控制台',
      addTitle: '添加停车场',
      editTitle: '修改停车场',
      deleteTitle: '确认操作',
      deleteConfirm: '是否确定删除该停车场？',
      numRequired: '停车场编号不能为空',
      typeRequired: '停车场类型不能为空',
      remarkPlaceholder: '可选，请填写备注',
      attr1: '区域大小',
      attr1Placeholder: '请输入区域大小',
      attr2: '停车类型',
      selectAttr2: '请选择停车类型',
      option1: '标准',
      option2: 'VIP',
      column1: '容量',
      column2: '可用',
      addSuccess: '停车场添加成功',
      addFailed: '停车场添加失败',
      editSuccess: '停车场修改成功',
      editFailed: '停车场修改失败',
      deleteSuccess: '停车场删除成功',
      deleteFailed: '停车场删除失败',
fetchError: '获取停车场数据失败'
    }
  },
  'zh-TW': {
    parkingAreaManage: {
      queryTitle: '查詢條件',
      parkingInfo: '停車場信息',
      parkingId: '停車場ID',
      parkingNum: '停車場編碼',
      parkingType: '停車場類型',
      inputParkingNum: '請輸入停車場編碼',
      selectParkingType: '請選擇停車場類型',
      aboveGround: '地上停車場',
      underground: '地下停車場',
      remark: '備註',
      createTime: '創建時間',
      operation: '操作',
      controlPanel: '控制台',
      addTitle: '添加停車場',
      editTitle: '修改停車場',
      deleteTitle: '確認操作',
      deleteConfirm: '是否確定刪除該停車場？',
      numRequired: '停車場編碼不能為空',
      typeRequired: '停車場類型不能為空',
      remarkPlaceholder: '可選，請填寫備註',
      attr1: '區域大小',
      attr1Placeholder: '請輸入區域大小',
      attr2: '停車類型',
      selectAttr2: '請選擇停車類型',
      option1: '標準',
      option2: 'VIP',
      column1: '容量',
      column2: '可用',
      addSuccess: '停車場添加成功',
      addFailed: '停車場添加失敗',
      editSuccess: '停車場修改成功',
      editFailed: '停車場修改失敗',
      deleteSuccess: '停車場刪除成功',
      deleteFailed: '停車場刪除失敗',
      fetchError: '獲取停車場數據失敗'
    }
  }
}